import PrimaryCell from "../../../../../ui/Table/Cells/PrimaryCell";
import NameCell from "./components/NameCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 75
  },
  {
    dataField: "name",
    caption: "Наименование",
    dataType: "string",
    cellRender: NameCell
  }
];
